export default __webpack_public_path__ + "static/media/ai.47dfa972.png";